import { render } from "./BaseSkeletonLoading.vue?vue&type=template&id=6d721cb2"
import script from "./BaseSkeletonLoading.vue?vue&type=script&lang=js"
export * from "./BaseSkeletonLoading.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__